<script>
  import { Pie } from 'vue-chartjs'

  export default {
    props: {
      graphData: {
        type: Object,
        default: () => {},
        required: false,
      },
    },

    extends: Pie,

    data() {
      return {
        options: {
          legend: {
            position: 'bottom',
          },

          tooltips: {
            enabled: false,
          },

          plugins: {
            datalabels: {
              formatter (value) {
                return Number(value) === 0 ? null : Number(value).toFixed(2) + '%'
              },

              backgroundColor: 'rgba(0, 0, 0, .5)',
              borderRadius: 4,
              color: '#fff',
            }
          }
        },
      }
    },

    computed: {
      plotData() {
        let data = {}

        data.labels = this.graphData.labels
        data.datasets = [{
          label: this.graphData.datasetTitle,
          data: this.graphData.data,
          backgroundColor: [
            'rgb(132,204,135)',
            'rgb(255,245,157)',
            'rgb(255,162,132)',
          ],
          borderWidth: 0,
        }]

        return data
      },
    },

    watch: {
      graphData() {
        this.renderChart(this.plotData, this.options)
      },
    },

    mounted () {
      this.renderChart(this.plotData, this.options)
    },
  }
</script>
